import Dashboard from 'Event/Dashboard'
import React from 'react'
import ActionsProvider from 'Event/ActionsProvider'
import {useObvioUser} from 'obvio/auth'
import {DesignBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'
import FullPageLoader from 'lib/ui/layout/FullPageLoader'

export default function DashboardConfig() {
  const user = useObvioUser()

  return (
    <ActionsProvider loader={<FullPageLoader />}>
      <DesignBreadcrumbs page="Dashboard">
        <Dashboard user={user} isEditMode />
      </DesignBreadcrumbs>
    </ActionsProvider>
  )
}
